<template>
  <div>
    <div ref="banner" v-show="bannerList.length>0">
      <swiper class="banner" v-if="bannerList.length>0" :options="swiperOption">
        <div class="swiper-slide" v-for="item in bannerList" :key="item.id">
          <a :href="item.link_content" v-if="item.link_type==1">
            <div class="slider-item" :style="{backgroundImage:'url('+item.banner_img+')'}"></div>
          </a>
          <router-link
            :to="{name:'CourseShow',params:{id:item.link_content}}"
            v-else-if="item.link_type==2"
          >
            <div class="slider-item" :style="{backgroundImage:'url('+item.banner_img+')'}"></div>
          </router-link>
          <router-link
            :to="{name:'NewsShow',params:{id:item.link_content}}"
            v-else-if="item.link_type==3"
          >
            <div class="slider-item" :style="{backgroundImage:'url('+item.banner_img+')'}"></div>
          </router-link>
          <router-link
            :to="{name:'BookDetail',params:{id:item.link_content}}"
            v-else-if="item.link_type==4"
          >
            <div class="slider-item" :style="{backgroundImage:'url('+item.banner_img+')'}"></div>
          </router-link>
          <router-link
            :to="{name:'LibraryDetail',params:{id:item.link_content}}"
            v-else-if="item.link_type==5"
          >
            <div class="slider-item" :style="{backgroundImage:'url('+item.banner_img+')'}"></div>
          </router-link>
          <div
            class="slider-item"
            :style="{backgroundImage:'url('+item.banner_img+')'}"
            v-else-if="item.link_type==0"
          ></div>
        </div>
        <div class="swiper-pagination" slot="pagination" v-if="bannerList.length>1"></div>
        <div class="swiper-button swiper-button-next" slot="button-prev" v-if="bannerList.length>1"></div>
        <div class="swiper-button swiper-button-prev" slot="button-next" v-if="bannerList.length>1"></div>
      </swiper>
    </div>
    <div
      class="section"
      :class="{'sec-odd':index%2==1}"
      v-for="(rec,index) in recommendList"
      :key="index"
    >
      <div
        class="title"
        :class="{'title-course':rec.channel_info.type==1,'title-tea':rec.channel_info.type==3}"
      >{{rec.channel_info.name}}</div>
      <RecommendTeacher :recommend="rec" v-if="rec.channel_info.type==3"></RecommendTeacher>
      <div v-else class="items" :class="'items-'+rec.channel_info.type">
        <template v-for="(item,index) in rec.list">
          <RichPublicItem
            v-if="rec.channel_info.type==5&&$store.state.template=='rich'"
            :key="index"
            :course="item"
          ></RichPublicItem>
          <RichCourseItem
            class="recommend-course-rich"
            v-if="rec.channel_info.type==1&&$store.state.template=='rich'"
            :key="index"
            :course="item"
          ></RichCourseItem>
          <BookItem v-if="rec.channel_info.type==7" :key="index" :item="item"></BookItem>
          <NewsRecommendItem v-if="rec.channel_info.type==6" :key="index" :item="item"></NewsRecommendItem>
        </template>
        <div style="clear:both;"></div>
      </div>
      <template v-if="rec.channel_info.show_more==1">
        <template v-if="rec.channel_info.type==1">
          <router-link
            v-if="rec.channel_info.show_more_url==1"
            class="more more-course"
            :class="{'more-course-rich':$store.state.template=='rich'}"
            :to="{name:'IndexRecommendCourse',query:{recommend:rec.channel_info.show_more_url==1?rec.channel_info.id:undefined,title:rec.channel_info.name}}"
          >查看更多</router-link>
          <router-link
            v-else
            class="more more-course"
            :class="{'more-course-rich':$store.state.template=='rich'}"
            :to="{name:'Course'}"
          >查看更多</router-link>
        </template>
        <template v-else-if="rec.channel_info.type==3">
          <router-link
            v-if="rec.channel_info.show_more_url==1"
            class="more more-teacher"
            :to="{name:'IndexRecommendTeacher',query:{recommend:rec.channel_info.show_more_url==1?rec.channel_info.id:undefined,title:rec.channel_info.name}}"
          >查看更多</router-link>
          <router-link v-else class="more more-teacher" :to="{name:'ShowTeachers'}">查看更多</router-link>
        </template>
        <template v-else-if="rec.channel_info.type==7">
          <router-link
            v-if="rec.channel_info.show_more_url==1"
            class="more more-book"
            :to="{name:'IndexRecommendBook',query:{recommend:rec.channel_info.show_more_url==1?rec.channel_info.id:undefined,title:rec.channel_info.name}}"
          >查看更多</router-link>
          <router-link v-else class="more more-book" :to="{name:'Book'}">查看更多</router-link>
        </template>
        <template v-else-if="rec.channel_info.type==6">
          <router-link
            v-if="rec.channel_info.show_more_url==1"
            class="more more-news"
            :to="{name:'IndexRecommendNews',params:{id:rec.channel_info.id},query:{title:rec.channel_info.name}}"
          >查看更多</router-link>
          <router-link v-else class="more more-news" :to="{name:'News'}">查看更多</router-link>
        </template>
        <template v-else-if="rec.channel_info.type==5">
          <router-link
            v-if="rec.channel_info.show_more_url==1"
            class="more more-public"
            :to="{name:'IndexRecommendCourse',query:{type:4,recommend:rec.channel_info.show_more_url==1?rec.channel_info.id:undefined,title:rec.channel_info.name}}"
          >查看更多</router-link>
          <router-link v-else class="more more-public" :to="{name:'Course',query:{type:4}}">查看更多</router-link>
        </template>
      </template>
    </div>
  </div>
</template>
<script>
import RichCourseItem from "../components/rich/CourseItem.vue";
import RecommendTeacher from "../components/recommend/RecommendTeacher.vue";
import BookItem from "@/components/BookItem.vue";
import RichPublicItem from "../components/rich/PublicCourseItem.vue";
import NewsRecommendItem from "../components/rich/NewsRecommendItem.vue";
export default {
  name: "Index",
  components: {
    BookItem,
    RichCourseItem,
    RichPublicItem,
    NewsRecommendItem,
    RecommendTeacher
  },
  data() {
    return {
      bannerList: [],
      openCourses: [],
      openCourseItmes: [],
      openCoursePage: 1,
      recommendList: [],
      currentTeacherIndex: 0
    };
  },
  computed: {
    swiperOption() {
      return {
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        loop: this.bannerList.length > 1,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      };
    },
    currentTeacher() {
      let recommend = this.recommendList.filter(
        r => r.channel_info.type == 3
      )[0];
      if (!recommend) {
        return;
      }
      return recommend.list[this.currentTeacherIndex];
    }
  },
  async created() {
    await this.getBanner();
    await this.getRecommend();
  },
  methods: {
    async getBanner() {
      this.bannerList = await this.$http.get("/api/app/banner");
    },
    async getRecommend() {
      let recommendList = await this.$http.get("/api/app/recommend/appIndex");
      recommendList.forEach(rec => {
        let count = 0;
        if (
          rec.channel_info.type == 3 ||
          rec.channel_info.type == 4 ||
          rec.channel_info.type == 6
        ) {
          count = 4;
        } else if (rec.channel_info.type == 7 || rec.channel_info.type == 1) {
          count = 6;
        } else if (rec.channel_info.type == 5) {
          count = 3;
        }
        if (count > 0) {
          rec.list = rec.list.splice(0, count);
        }
      });
      this.recommendList = recommendList;
    },
    getScrollWidth() {
      let noScroll,
        scroll,
        oDiv = document.createElement("DIV");
      oDiv.style.cssText =
        "position:absolute; top:-1000px; width:100px; height:100px; overflow:hidden;";
      noScroll = document.body.appendChild(oDiv).clientWidth;
      oDiv.style.overflowY = "scroll";
      scroll = oDiv.clientWidth;
      document.body.removeChild(oDiv);
      return noScroll - scroll;
    }
  },
  mounted() {
    this.$nextTick(() => {
      let scrollWidth = this.getScrollWidth();
      this.$refs.banner.style.height =
        "calc((100vw - " + scrollWidth + "px) * 420 / 1920";
    });
  }
};
</script>
<style lang="scss" scoped>
.banner {
  height: 100%;
  overflow: hidden;

  &:hover {
    .swiper-button {
      display: block;
    }
  }

  .slider-item {
    height: 100%;
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }

  .swiper-button {
    width: 38px;
    height: 54px;
    position: absolute;
    background-size: 100% 100%;
    z-index: 9999;
    display: none;
  }

  .swiper-button-prev {
    background-image: url("~@/assets/images/index/banner-left@2x.png");
    left: calc((100vw - 1200px) / 2);
  }

  .swiper-button-next {
    background-image: url("~@/assets/images/index/banner-right@2x.png");
    right: calc((100vw - 1200px) / 2);
  }
}

.shadow {
  box-shadow: 0px 6px 20px 0px rgba(65, 105, 255, 0.04),
    0px 13px 33px 0px rgba(0, 0, 0, 0.04) !important;
  transition: all 0.5s !important;
  background: white;
  background-color: white;

  &:hover {
    box-shadow: 0px 11px 55px 10px rgba(0, 0, 0, 0.07),
      0px 13px 18px -8px rgba(0, 0, 0, 0.15) !important;
  }
}

.section {
  padding-top: 48px;
  overflow: hidden;

  .title {
    font-size: 34px;
    font-weight: 500;
    color: #2b2d2e;
    line-height: 1;
    text-align: center;
    margin-bottom: 44px;
  }

  .title-course {
    margin-bottom: 40px;
  }

  .title-tea {
    margin-bottom: 24px;
  }

  .items {
    width: 1200px;
    margin: 0 auto;
  }

  .items-5 {
    padding-bottom: 48px;
  }

  .more {
    display: block;
    margin: 48px auto;
    width: 160px;
    height: 42px;
    background: transparent;
    border-radius: 21px;
    border: 1px solid rgba(217, 217, 217, 1);
    box-sizing: border-box;
    font-size: 16px;
    color: #999999;
    line-height: 40px;
    text-align: center;

    &:hover {
      background: $primary-color;
      color: white;
      border-color: $primary-color;
    }
  }

  .more-course-rich {
    margin-top: 3px;
  }

  .more-book {
    margin-top: 12px;
  }

  .more-teacher {
    margin-top: 0;
  }

  .more-public {
    margin-top: 0;
  }
}

.sec-odd {
  background-color: white;
}

.recommend-course {
  /deep/ {
    .course-title {
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      font-size: 22px;
    }
  }

  &:hover::before {
    display: none;
  }
}
</style>
